import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Record<string, Array<import('modules/statistics/types').Answer>>} */
const initialState = null;

/**
 * Parse a question payload (new format) into a flat list of `{ name, value, parent, filterKey }`.
 * Generic: any key in `response` other than `count` is treated as a subset.
 *
 * @param {{ count: number, [subset: string]: number }} response
 * @param {string} name parent response key (e.g. 'YES')
 * @returns {Array<import('modules/statistics/types').Answer>}
 */
const parseResponse = (response, name) => {
  const { count, ...subsets } = response;
  const parentEntry = { name, value: count, parent: null, filterKey: name };
  const subsetEntries = Object.entries(subsets).map(([subsetName, subsetValue]) => ({
    name: subsetName,
    value: subsetValue,
    parent: name,
    filterKey: `${name}_${subsetName}`,
  }));
  return [parentEntry, ...subsetEntries];
};

/**
 * @param {Record<string, Array<import('modules/statistics/types').Answer>>} state
 * @param {import('modules/statistics/types').SetAnswersAction} action
 * @returns {Record<string, Array<import('modules/statistics/types').Answer>>}
 */
const setAnswers = (state, { payload }) => payload.reduce((acc, { questionId, responses }) => {
  const formattedAnswers = Object.entries(responses ?? {})
    .flatMap(([name, response]) => parseResponse(response, name));

  return {
    ...acc,
    [questionId]: formattedAnswers,
  };
}, {});

const clearData = () => initialState;

export default createReducer(initialState, {
  [types.QUESTION_MODEL_STATISTICS_ANSWERS_SUCCESS]: setAnswers,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: clearData,
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: clearData,
});
